<div
    class="p-4 pt-0 align-self-center min-login-size"
    style="position: absolute;"
>
    <div class="login-logo"></div>
    <mat-card class="p-4 pt-0 align-self-center">
        @if (completed) {
        <mat-card-header>
            <mat-card-title class="mt-4">Your account is ready</mat-card-title>
            @if (canAccessApp) {
            <mat-card-subtitle>Sign in using the Fire Survey Pro mobile app.</mat-card-subtitle>
            } @else {
            <mat-card-subtitle>Your password has been created.</mat-card-subtitle>
            }
        </mat-card-header>

        <mat-card-content class="account-ready-content">
            @if (canAccessApp) {
            <p>This account has been set up for mobile surveying rather than browser access.</p>
            <div class="app-download-actions">
                <a mat-stroked-button color="primary" [href]="appStoreUrl" target="_blank" rel="noopener">Download for iPhone</a>
                <a mat-stroked-button color="primary" [href]="playStoreUrl" target="_blank" rel="noopener">Download for Android</a>
            </div>
            } @else {
            <p>Access has not been enabled yet. Please contact your organisation administrator.</p>
            }
        </mat-card-content>
        } @else {
        <mat-card-header>
            <mat-card-title class="mt-4">{{ invitation ? 'Hello, ' + invitation.name : 'Create your password' }}</mat-card-title>
            @if (invitation?.tenant_name) {
            <mat-card-subtitle>You’ve been invited to join {{ invitation.tenant_name }}.</mat-card-subtitle>
            } @else {
            <mat-card-subtitle>Choose a password to finish setting up your account.</mat-card-subtitle>
            }
        </mat-card-header>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
            <mat-card-content>
                @if (invitation) {
                <p class="invitation-email">{{ invitation.email }}</p>
                }
                <mat-form-field>
                    <input
                        type="password"
                        matInput
                        [ngClass]="{
                            'is-invalid': submitted && f.password.errors
                        }"
                        placeholder="Password"
                        formControlName="password"
                        autocomplete="new-password"
                    />
                    @if (submitted && f.password.errors) {
                    <div class="invalid-feedback">
                        @if (f.password.errors.required) {
                        <div>
                            Password is required.
                        </div>
                        }
                    </div>
                    }
                </mat-form-field>

                <mat-form-field>
                    <input
                        type="password"
                        matInput
                        [ngClass]="{
                            'is-invalid': submitted && f.password.errors
                        }"
                        placeholder="Confirm Password"
                        formControlName="password_confirmation"
                        autocomplete="new-password"
                    />
                    @if (submitted && f.password.errors) {
                    <div class="invalid-feedback">
                        @if (f.password.errors.required) {
                        <div>
                            Please confirm your password.
                        </div>
                        }
                    </div>
                    }
                </mat-form-field>

                <div class="col-12 mt-3">
                    @if (error) {
                    <div class="alert alert-danger mt-1">{{ error }}</div>
                    }
                </div>
            </mat-card-content>

            <mat-card-actions class="m-0">
                <button type="submit" mat-flat-button color="primary">
                    Submit
                </button>
                <a mat-button color="primary" routerLink="/login"
                    >Return to login</a
                >
            </mat-card-actions>
        </form>
        }
    </mat-card>
</div>
